<template>
  <div class="dropdown-block">

    <!-- Burger list -->
    <div class="dropdown-block-list" v-if="currentList.length">
      <div class="dropdown-block-list-back" @click="closeBurger">
        <img src="../../../../../../assets/shop/back-arrow.png" class="dropdown-block-list-back-arrow" width="64" height="64" alt="back-icon" loading="eager" fetchpriority="high">
        <span class="dropdown-block-list-back-naming"> {{ listNaming }} </span>
      </div>
      <div class="dropdown-block-list-all" @click="checkAll">
        <span class="dropdown-block-list-all-naming"> {{ $t('View all') }} </span>
        <span class="dropdown-block-list-all-count"> {{ getAllCategoryProducts }} </span>
      </div>
      <burger-link v-for="item in currentList"
                   :item="item"
                   :key="item.id"
      />
    </div>
    <div v-else>
      <bounce-loader />
    </div>
    <!---->

  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import BurgerLink from 'theme/components/core/blocks/Shop/Navigation/Burger/BurgerLink'
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'
import { mapGetters } from 'vuex'

export default {
  components: {
    BurgerLink,
    BounceLoader
  },
  props: {
    currentList: {
      type: Array
    },
    listNaming: {
      type: String
    },
    currentCategory: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    },
    getAllCategoryProducts () {
      return this.currentList.reduce((sum, el) => sum + el.product_count, 0)
    }
  },
  methods: {
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    },
    closeBurger () {
      this.$bus.$emit('beck-burger')
    },
    checkAll () {
      this.$bus.$emit('hide-burger-menu')
      this.$bus.$emit('close-burger')
      this.$bus.$emit('hide-overlay-in-shop')
      this.$bus.$emit('change-close-btn')
      this.$router.push(this.categoryLink(this.currentCategory))
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-block {
  width: 300px;
  height: 100%;

  position: fixed;
  left: 0;
  display: flex;

  background: #fff;
  z-index: 3;

  &-list {
    width: 100%;
    height: calc(100vh - 105px); // 105px - height of header and navigation

    display: flex;
    flex-direction: column;

    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #fff;
    }

    &::-webkit-scrollbar-thumb {
      width: 0;
      border-radius: 10px;
      background: #f5a623;
    }

    &-back {
      width: 100%;
      padding: 15px 20px;

      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(159, 159, 159, .2);
      box-sizing: border-box;

      &-arrow {
        width: 16px;
        height: 16px;
        margin-right: 15px;
      }

      &-naming {
        color: #000;
        font-size: 14px;
        font-weight: 600;
      }
    }

    &-all {
      width: 100%;
      padding: 15px 20px;

      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      box-sizing: border-box;

      &:before {
        width: 93%;
        height: 1px;
        margin: auto;

        position: absolute;
        bottom: 0;
        right: 0;
        content: '';

        background: rgba(159, 159, 159, .2);
      }

      &-naming {
        color: #111;
        font-size: 14px;
        font-weight: 400;
      }

      &-count {
        color: rgb(159, 159, 159);
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
}
</style>
